const els = {
	videoTitle: document.querySelector('.shopify-section .dermatology-experts-videos .title'),
	dermCard: document.querySelector('.shopify-section .better-faster-results .multicolumn-card')
}

const isArmCreamPage = document.querySelector('body').dataset.templateSuffix === 'landing-pdp-arm-cream' || 'pdp-arm-cream';

const onHighlightEffect = (match, str) => {
	const regex = new RegExp(match, 'g')
	return str.replace(regex, `<em><strong>${match}</strong></em>`)
}

if (els.videoTitle) {
	const template = document.querySelector('body').dataset.templateSuffix;
	const highlightText = template === ('landing-pdp-arm-cream' || 'pdp-arm-cream') ? 'Real Results' : '200 million views';
	els.videoTitle.classList.add('highlight-effect');
	els.videoTitle.innerHTML = onHighlightEffect(highlightText, els.videoTitle.textContent);
}

if (els.dermCard && !isArmCreamPage) {
	const div = document.createElement('div')
	div.classList = 'derm-extra-content'
	div.innerHTML = `
		<p>"I recommend this neck cream because I'm confident in the science-backed results."</p>
		<p>
			<span>Dr. Trisha Khanna</span>
			<span>goPure Dermatology Advisor</span>
		</p>
	`
	els.dermCard.appendChild(div)
}

if (window.hightlightEffect) window.hightlightEffect()

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-video-thumbnail]').forEach($el => {
		$el.addEventListener('click', () => {
			const videoId = $el.dataset.videoThumbnail;
			$el.classList.add('multicolumn-card__image-wrapper--hidden');
			window._wq = window._wq || [];
			_wq.push({
				id: videoId,
				onReady: function (video) {
					video.play();
				}
			});
		});
	});
	document.querySelectorAll('.selection-card').forEach(($el) => $el.addEventListener('click', () => {
		const $wrapper = $el.closest('.buy-box--options');
		const $buyboxes = $wrapper.querySelectorAll('.product-form-tabs');
		$el.closest('.bundle-upsells').querySelector('.selection-card--active').classList.remove('selection-card--active');
		$el.classList.add('selection-card--active');
		$buyboxes.forEach($buybox => $buybox.style.display = 'none');
		$wrapper.querySelectorAll(`.product-form-tabs[data-product="${$el.dataset.product}"]`).forEach($buybox => $buybox.style.display = 'block');
	}));
	const bundleModal = document.querySelector('[data-quick-modal-content]');
	if (bundleModal) {
		const quickModal = document.querySelector('.quick-modal');
		const quickModalToggle = document.querySelectorAll('[data-quick-modal-toggle]');

		quickModalToggle.forEach(el => el.addEventListener('click', () => {
			quickModal.classList.toggle('quick-modal--open');
		}));

		const bundleContent = document.querySelectorAll('.slider-product')[1];
		const clonedContent = bundleContent.cloneNode(true);
		const button = document.createElement("button");
		button.textContent = 'Close';
		button.classList.add('quick-modal__cta');
		button.addEventListener('click', () => quickModal.classList.toggle('quick-modal--open'));

		bundleModal.innerHTML = clonedContent.outerHTML;
		bundleModal.querySelector('.buy-box--options').remove();
		bundleModal.querySelector('.buy-box--product').querySelector('.buy-box--details').appendChild(button);
	}
});

